import { Input } from '@servicetim/ui/components';
import { type ComponentProps, useId, useMemo } from 'react';

let cachedZones: string[] | null = null;

/** IANA zones from the platform (the same database `TimeZoneSchema` validates against). */
export function timeZones(): string[] {
  if (cachedZones) return cachedZones;
  try {
    cachedZones = Intl.supportedValuesOf('timeZone');
  } catch {
    cachedZones = ['UTC'];
  }
  return cachedZones;
}

/** Text input with a datalist of IANA time zones; the value stays a plain string. */
export function TimeZoneInput(props: ComponentProps<'input'>) {
  const listId = useId();
  const zones = useMemo(timeZones, []);
  return (
    <>
      <Input {...props} list={listId} autoComplete="off" placeholder={props.placeholder ?? 'UTC'} />
      <datalist id={listId}>
        {zones.map((zone) => (
          <option key={zone} value={zone} />
        ))}
      </datalist>
    </>
  );
}
